export function getLocaleWithoutDialect(locale: string): string {
    return locale.split('-').slice(0, 2).join('-');
}
